import { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { SelectOption } from "@/shared/models/ui-using/SelectOption";
import { Utils } from "@/shared/utils/Utils";

interface IProps {
  label: string;
  placeHolder: string;
  defaultSelectedOptions?: string[];
  options: SelectOption[];
  selectChanged: (selectedItems: any[]) => void;
}

export default function FormGroupMultiSelectOutside({
  label,
  placeHolder,
  options,
  defaultSelectedOptions,
  selectChanged,
}: IProps) {
  const [selectedOptions, setSelectedOptions] = useState<string[]>(defaultSelectedOptions || []);

  useEffect(() => {
    setSelectedOptions((prev) => {
      const next = defaultSelectedOptions ?? [];
      const isSame = Utils.areObjectsEqual(prev, next);
      return isSame ? prev : next;
    });
  }, [defaultSelectedOptions]);

  const handleAddOption = (e: React.ChangeEvent<HTMLSelectElement>) => {
    if (selectedOptions.includes(e.target.value) || e.target.value === "") return;
    let newSelectedOptions = [...selectedOptions, e.target.value];
    setSelectedOptions(newSelectedOptions);
    selectChanged(newSelectedOptions);
  };

  const handleRemoveOption = (optionToRemove: string) => {
    let newSelectedOptions = selectedOptions.filter((option) => option !== optionToRemove);
    setSelectedOptions(newSelectedOptions);
    selectChanged(newSelectedOptions);
  };

  return (
    <Form.Group>
      <Form.Label>{label}</Form.Label>
      <Form.Select onChange={handleAddOption} value="">
        <option value="">{placeHolder}</option>
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </Form.Select>

      <div className="mt-2" style={{ minHeight: "32px" }}>
        {selectedOptions.map((option) => {
          return (
            <span key={option} className="badge bg-primary me-2 mb-1">
              {options.filter((item) => item.value === option)[0]?.label}
              <button
                type="button"
                className="btn-close btn-close-white ms-2"
                aria-label="Remove"
                onClick={() => handleRemoveOption(option)}
                style={{ fontSize: "0.7em" }}
              ></button>
            </span>
          );
        })}
      </div>
    </Form.Group>
  );
}
